import { HDM_ACCOUNT_PATHS, HDM_CATALOG_SEO_PATHS } from '@/data/constants/urlPathConstants';
import { Token } from '@/data/types/Token';
import { normalizeStoreTokenPath } from '@/data/utils/normalizeStoreTokenPath';
import { ParsedUrlQuery } from 'querystring';

/**
 * Context path parse support for backward compatibility of ReactJs(Emerald) implementation.
 * @param path
 * @param contextPath
 * @returns
 */
export const getIdFromPath = (path: ParsedUrlQuery['path'], storeToken: Token = {}) => {
	// Ensure path is an array
	const pathArray = Array.isArray(path) ? path : typeof path === 'string' ? [path] : [];
	if (pathArray[0] === HDM_ACCOUNT_PATHS.Account && pathArray[1]) {
		return pathArray[1];
	}

	// Remove first segment if it's in urlPaths
	const cleanedPath = Object.values(HDM_CATALOG_SEO_PATHS).includes(pathArray[0])
		? pathArray.slice(1)
		: pathArray;

	// Normalize and join
	const normalizedPath = [
		normalizeStoreTokenPath({ path: cleanedPath, storeUrlKeyword: storeToken.urlKeywordName }),
	]
		.flat()
		.filter(Boolean)
		.join('/');

	return normalizedPath || 'nextjs-home';
};
